"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccessToken = void 0;
const cookie_1 = require("../cookie/cookie");
function getAccessToken() {
    const token = (0, cookie_1.getCookie)('uscca_access');
    if (token) {
        const encodedValue = token.split('.')[1];
        return JSON.parse(window.atob(encodedValue));
    }
    return undefined;
}
exports.getAccessToken = getAccessToken;
